import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" {...props}><title>icon/arrow-nav-chevron-1-1</title><path d="M8.5 7.57l-5.16 5.14a.7.7 0 000 1c.28.27.73.27 1.02 0l6.35-6.32a.7.7 0 00.2-.5v-.02a.7.7 0 00-.27-.55L4.36.07a.72.72 0 00-1.02 0 .7.7 0 000 1l5.12 5.1.05 1.4" fill="#979797" fillRule="nonzero" /></svg>);